<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Resumen de Transportes</h3>
        </b-col>
        <b-col class="text-right">
      <!-- Botón para alternar la visibilidad de la tabla -->
   <base-button @click="mostrarTabla = !mostrarTabla" size="sm" type="primary">
        {{ mostrarTabla ? 'Ocultar -' : 'Mostrar +' }}
      </base-button>
    </b-col>
      </b-row>
    </template>

    <el-table
    v-if="mostrarTabla"
      class="table-responsive table"
      :data="datosTabla"
      header-row-class-name="thead-light"
    >
      <!-- Columna de Jornada -->
                <el-table-column
            label="Jornada"
            min-width="90px">
            <template v-slot:default="{ row }">
              <div :style="{ color: obtenerColorJornada(row.jornada) }"><b>{{ row.jornada }}</b></div>
            </template>
          </el-table-column>

      <!-- Columna de Transporte -->
      <el-table-column
        prop="transporte"
        label="Transporte"
        min-width="180px">
        <template v-slot:default="{ row }">
          <div>{{ row.transporte }}</div>
        </template>
      </el-table-column>

      <!-- Columna de Viajes -->
      <el-table-column
        prop="viajes"
        label="Viajes"
        min-width="70px">
        <template v-slot:default="{ row }">
          <div>{{ row.viajes }}</div>
        </template>
      </el-table-column>

            <!-- Columna de Camiones -->

      <el-table-column
        prop="placas"
        label="Camiones"
        min-width="70px">
        <template v-slot:default="{ row }">
          <div>{{ row.placas }}</div>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>


<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import moment from 'moment'

export default {
  name: 'camiones-table',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    listaJornada: {
      type: Array,
      default: () => [],
    },
    listaDatosData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mostrarTabla: true, // Controla la visibilidad de la tabla
      coloresJornada: [
      "rgba(0, 77, 107, 1)", // #004D6B
      "rgba(190, 219, 225, 1)", // #BEDBE1
      "rgba(0, 139, 139, 1)", // #008B8B
      "rgba(255, 175, 29, 1)", // #FFAF1D
      "rgba(255, 104, 0, 1)", // #FF6800
    ],
    };
  },
  methods:{

    obtenerColorJornada(jornadaNombre) {
    let hash = 0;
    for (let i = 0; i < jornadaNombre.length; i++) {
      hash = jornadaNombre.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colorIndex = Math.abs(hash) % this.coloresJornada.length;
    return this.coloresJornada[colorIndex];
  },

    convertir(item) {
      if (typeof (item) === "string")
        return parseFloat(item.replace(",", "."))
      if (typeof (item) === "number")
        return parseFloat(item.toString())

    },
    
    Jornada(idproductophite) {
         let pnetoTotal = ''
        let res =  this.listaJornada.filter(val => {
            return val.ID == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.JORNADA
        });

      return pnetoTotal;

      },

      ViajesTransporte(row) {
          let res = this.listaDatosData.filter(val => {
            // Asumo que row es el índice directamente
            return val.TRANSPORTE == row.name != 0;
          });

          return res.length;
        },


 

        obtenerNombreTransporte(transporte) {
          const nombre = transporte.name;
          return nombre !== 0 ? nombre : "TRANSPORTE DESCONOCIDO*";
        },

      
     
      ViajesBalanza(idproductophite) {
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite != 0;
        }).filter(function( element ) {
        return element.PESO_NETO_PUERTO !== 0;
        })
         return res.length;
      },

      PnetoBalanza(idproductophite) {
         let pnetoTotal = 0
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_PUERTO
        });

      return pnetoTotal.toFixed(3);

      },

      DiferenciaJornadaPhite(idproductophite) {
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })
        

        res.forEach(element => {
         element.FECHA_FIN_CARGIO
        });

        let beta =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })
        

        beta.forEach(element => {
         element.FECHA_INICIO_CARGUIO
        });

        var date2 = moment(beta[beta.length -1].FECHA_FIN_CARGIO, 'DD-MM-YYYY HH:mm').format('MM-DD-YYYY HH:mm');
        var date1 = moment(res[0].FECHA_INICIO_CARGUIO, 'DD-MM-YYYY HH:mm').format('MM-DD-YYYY HH:mm');
        // var diff = date2.diff(date1, 'minutes');        

        var now = moment(date1),
        end = moment(date2),
        minutes = end.diff(now, 'Minutes');

        return minutes/60

      },

      PnetoAlmacenEnAlmacen(idproductophite) {
         let pnetoTotal = 0
        let res =  this.DataCompletaAlmacen.filter(val => {
            return val.JORNADA == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_ALMCEN
        });

      return pnetoTotal.toFixed(3);

      },


  },
  computed: {

    datosTabla() {
    // Agrupamos los datos por JORNADA y TRANSPORTE
    const agrupados = this.listaDatosData.reduce((acc, item) => {
      const clave = `${item.JORNADA}|${item.TRANSPORTE}`;
      if (!acc[clave]) {
        acc[clave] = {
          jornadaId: item.JORNADA,
          transporte: item.TRANSPORTE,
          placas: new Set(), // Usamos un Set para mantener las PLACAS únicas
          viajes: 0 // Inicializamos el conteo de viajes
        };
      }
      acc[clave].placas.add(item.PLACA); // Añadimos la PLACA al Set para contar placas únicas
      acc[clave].viajes += 1; // Incrementamos el conteo de viajes
      return acc;
    }, {});

    // Convertimos el objeto agrupado en un array y ajustamos los datos para la visualización
    return Object.values(agrupados).map(item => {
      const jornadaObj = this.listaJornada.find(j => j.ID === item.jornadaId);
      const nombreJornada = jornadaObj ? jornadaObj.JORNADA : 'Nombre no encontrado';
      const colorIndex = this.listaJornada.findIndex(j => j.ID === item.jornadaId) % this.coloresJornada.length;
      const colorJornada = this.coloresJornada[colorIndex];
      // Calculamos la cantidad de PLACAS únicas
      const cantidadPlacas = item.placas.size;

      return {
        jornada: nombreJornada, // Nombre de la jornada
        transporte: item.transporte, // Nombre del transporte
        viajes: item.viajes, // Cantidad de viajes
        placas: cantidadPlacas, // Cantidad de placas distintas
        color: colorJornada, // Agregar el color de la jornada

      };
    });
  },



    TransporteUnico() {
      let unique = [
        ...new Set(this.listaDatosData.map((productlist) => productlist.TRANSPORTE)),
      ];
      return unique.map((name) => ({ name }));
    },

    JornadaFiltrada() {
      return this.JornadaUnica.filter(row => this.ViajesBalanza(row) > 0);
    },

    JornadaUnica() {
      let jornada = [
        ...new Set(this.listaJornada.map((productlist) => productlist.ID)),
      ];
      return jornada;
    },

    DataCompleta() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_PUERTO: this.convertir(item.PESO_NETO_PUERTO),
          ID_PRODUCTO: item.ID_PRODUCTO,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          FECHA_INICIO_CARGUIO: item.FECHA_INICIO_CARGUIO,
          FECHA_FIN_CARGIO: item.FECHA_FIN_CARGIO,
          JORNADA: item.JORNADA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
        };
            }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        })
              },

              DataCompletaAlmacen() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_ALMCEN: this.convertir(item.PESO_NETO_ALMCEN),
          FECHA_INGRESO_ALMACEN: item.FECHA_INGRESO_ALMACEN,
          PLACA: item.PLACA,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          JORNADA: item.JORNADA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
                };
            }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== undefined;
        }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== 0;
        })
      },
         

  },
};
</script>

<style>
</style>
